import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { getPendingApprovals } from "../../../../../store/slices/pending-approval.slice";
import PendingApprovalTableComponent from "./pending-approval-table.component";

const PendingApprovalComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("profileName"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Profile Name",
      label: "profileName",
      isSorted: true,
    },
    // {
    //   title: "Email",
    //   label: "email",
    // },
    {
      title: "Role",
      label: "roleName",
    },
    {
      title: "Requested Action",
      label: "requestedAction",
    },
    {
      title: "Requested By",
      label: "requestedBy",
    },
  ]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getPendingApprovals({ PageNumber, pageSize, SortBy, SortDirection })
    );
  }, [dispatch, PageNumber, SortBy, SortDirection]);

  const pendingApprovalData = useSelector((state: any) => {
    return state.pendingApproval.pendingApprovals;
  });

  const isLoading = useSelector((state: any) => {
    return state.pendingApproval.isLoading;
  });

  const onRefetchData = () => {
    dispatch(
      getPendingApprovals({ PageNumber, pageSize, SortBy, SortDirection })
    );
  };

  const [updatedPendingApproval, setUpdatedPendingApproval] = useState([]);

  useEffect(() => {
    if (!pendingApprovalData?.data?.length) {
      setUpdatedPendingApproval([]);
      return;
    }

    const filteredData = pendingApprovalData?.data?.filter(
      (item: any) => item.roleId !== 1
    );
    setUpdatedPendingApproval(filteredData);
  }, [pendingApprovalData]);

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <PendingApprovalTableComponent
        columns={columns}
        data={updatedPendingApproval}
        totalNumberOfRecords={updatedPendingApproval?.length}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoading}
      />
    </div>
  );
};

export default PendingApprovalComponent;
